<div class="g-0">
    <div class="col">
        <div class="box-wrapper box-documentUat">
            <div class="box-content-header box-content-header-documentUat">
                <div class="row p-1">
                    <div class="col">
                        <mat-card-title class="d-flex justify-content-between">
                            <span>
                                <i class="fa-solid fa-edit"></i>
                                <span>Notificare instituție fiscală</span>
                            </span>
                            <span class="action-buttons">
                                <button *ngIf="cerere.info.id_institutie === null" type="button" class="btn btn-info d-flex justify-content-center align-items-center" (click)="exportDocumentUat()">
                                    <ng-container *ngIf="isExportLoading; else exportDocument">
                                        <mat-spinner diameter="20"></mat-spinner>
                                    </ng-container>
                                    <ng-template #exportDocument>
                                        <i class="fa-regular fa-file"></i>
                                    </ng-template>
                                    Generează document
                                </button>
                                <button *ngIf="cerere.info.id_institutie !== null" type="button" class="btn btn-info" (click)="retrimiteNotificare()">
                                    Retrimite notificare
                                </button>
                            </span>
                        </mat-card-title>
                    </div>
                </div>
            </div>
            <div *ngIf="cerere.info.id_institutie === null" class="box-content-body p-2">
                <div class="row">
                    <div class="col">
                        <div class="fw-bold">Adăugați un mesaj</div>
                    </div>
                </div>
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col">
                            <angular-editor formControlName="notificare_uat" [config]="editorConfig"></angular-editor>
                            <mat-error *ngIf="form.get('notificare_uat')?.touched && form.get('notificare_uat')?.invalid">
                                Câmp obligatoriu
                            </mat-error>
                        </div>
                    </div>

                    <div class="row my-3">
                        <div class="col">
                            <button *ngIf="!showForm" type="button" class="btn btn-warning pull-right" (click)="showFormUat()">
                                Adaugă instituție
                            </button>   
                            <form *ngIf="showForm" [formGroup]="formUat">
                                <div class="row">
                                    <div class="col">
                                        <mat-form-field class="w-100">
                                            <mat-label>Denumire</mat-label>
                                            <input type="text" matInput formControlName="denumire_institutie"/>
                                            <mat-error *ngIf="formUat.get('denumire_institutie')?.touched && formUat.get('denumire_institutie')?.invalid">
                                                Câmp obligatoriu
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <mat-form-field class="w-100">
                                            <mat-label>Adresa de email</mat-label>
                                            <input type="email" matInput formControlName="email_institutie"/>
                                            <mat-error *ngIf="formUat.get('email_institutie')?.touched && formUat.get('email_institutie')?.invalid">
                                                Câmp obligatoriu
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col">
                                        <mat-form-field class="w-100">
                                            <mat-label>Locație</mat-label>
                                            <input type="text" matInput formControlName="locatie"/>
                                            <mat-error *ngIf="formUat.get('locatie')?.touched && formUat.get('locatie')?.invalid">
                                                Câmp obligatoriu
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col">
                                        <mat-form-field class="w-100">
                                            <mat-label>Telefon</mat-label>
                                            <input type="text" matInput formControlName="telefon"/>
                                        </mat-form-field>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col">
                                        <div class="d-flex justify-content-end align-items-center">
                                            <button type="button" class="btn btn-warning me-2" (click)="showFormUat()">
                                                Închide
                                            </button>
        
                                            <button type="submit" class="btn btn-success" (click)="submitFormUat()" [disabled]="formUat.invalid">
                                                Adaugă
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="row p-1">
                        <div class="col">
                            <mat-form-field class="w-100">
                                <mat-label>Adaugă instituție</mat-label>
                                <mat-chip-grid #chipGrid aria-label="Selectare instituție">
                                    <mat-chip-row *ngFor="let institution of institutions"
                                        (removed)="removeInstitution(institution)">
                                        {{ institution.denumire_institutie }}
                                        <button matChipRemove [attr.aria-label]="'remove ' + institution.denumire_institutie">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                </mat-chip-grid>
                                <input #institutionInput
                                    [formControl]="institutionsCtrl" [matChipInputFor]="chipGrid"
                                    [matAutocomplete]="auto"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    (matChipInputTokenEnd)="addInstitution($event)" />
                                <mat-autocomplete #auto="matAutocomplete"
                                    (optionSelected)="selectedInstitutions($event)">
                                    <mat-option *ngFor="let institution of filteredInstitutions | async"
                                        [value]="institution">
                                        {{ institution.denumire_institutie }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="container__upload d-flex flex-column">
                        <div class="container__upload-header d-flex flex-row justify-content-between align-items-center">
                            <p class="m-0">Fotografii/Documente</p>
                            <button type="button" class="upload-btn" (click)="fileInput.click()">
                                <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                ÎNCARCĂ
                            </button>
                        </div>
                        <div class="container__upload-files" *ngIf="form.value.files && form.value.files.length > 0">
                            <div class="container__upload-file d-flex flex-row justify-content-between align-items-center" *ngFor="let uploadedFile of form.value.files; let i = index">
                                <span class="container__upload-file-name">
                                    {{ (uploadedFile.name && uploadedFile.name.length > 50) ? (uploadedFile.name | slice: 0:50) + '..' : (uploadedFile.name) }}
                                </span>
            
                                <mat-spinner diameter="32" *ngIf="uploading[i]"></mat-spinner>
                                <div>
                                    <button class="container__upload-file-delete d-flex" type="button" matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                                        <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                                    </button>
                                </div>
                            </div>
                        </div>
            
                        <input type="file" accept="application/pdf" id="upload-file-input-0" #fileInput
                            name="fileInput" (change)="addFile($event)" multiple style="display: none">
                    </div>

                    <div class="col d-flex justify-content-end">
                        <button class="btn btn-light upload-btn m-3" type="submit" (click)="submitForm()" [disabled]="form.invalid">
                            <span class="upload__text">TRIMITE</span>
                        </button>
                    </div>
                </form>
            </div>

            <div *ngIf="cerere.info.id_institutie !== null" class="box-content-body p-2">
                <div [innerHTML]="cerere.notificare_uat_history.content"></div>
                <hr>
                <p>
                    Notificare trimisă la data de {{ formatCreatedAt(cerere.notificare_uat_history.created_at) }}
                </p>
                <p>
                    Către instituția {{ cerere.notificare_uat_history.institutie_nume }}
                </p>
                <p>
                    La adresa de email {{ cerere.notificare_uat_history.institutie_email }}
                </p>
                <hr>
                <div *ngIf="cerere.documente_uat_notificare.length > 0" class="document-attachement p-2">
                    <button type="button" class="btn btn-light upload-btn m-2"
                        *ngFor="let document of cerere.documente_uat_notificare" (click)="downloadDocument(document)">
                        <span class="upload__text">
                            {{ document.old_name }}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>